import { useMemo } from "react";

import { Field, Label } from "V2.0/common/fieldset";
import { CheckboxGroup } from "V2.0/common/checkbox";

import SectionCheckboxField from "./SectionCheckboxField";

import { Tooltip } from "antd";
import { InformationCircleIcon } from "@heroicons/react/24/outline";

import { AssistantSection } from "V2.0/models/UserProfile";

export default AssistantSectionsVisibility;

interface AssistantSectionsVisibilityProps {
  visibleSections: Array<AssistantSection>;
  onHideSection: (sectionName: AssistantSection) => void;
  onUnhideSection: (sectionName: AssistantSection) => void;
  disabled: boolean;
}

function AssistantSectionsVisibility(props: AssistantSectionsVisibilityProps) {
  const { visibleSections, onHideSection, onUnhideSection, disabled } = props;

  const assistantSections = useMemo(() => {
    return Object.keys(AssistantSection).map((section) => {
      const sectionValue = AssistantSection[section];
      return {
        name: sectionValue,
        label: section,
        isChecked: visibleSections.includes(sectionValue),
      };
    });
  }, [visibleSections]);

  const assistantSectionCheckboxFields = assistantSections.map(
    (section, idx) => {
      return (
        <SectionCheckboxField
          key={idx}
          isFirst={idx === 0}
          section={section}
          disabled={disabled}
          onHideSection={onHideSection}
          onUnhideSection={onUnhideSection}
        />
      );
    },
  );

  return (
    <Field disabled={disabled}>
      <Label className="flex items-center gap-x-2">
        Assistant Sections
        <Tooltip title="Applies only to Operator Role">
          <InformationCircleIcon className="size-4" />
        </Tooltip>
      </Label>
      <CheckboxGroup className="grid grid-cols-2 rounded-lg px-4 pt-2 py-4 space-y-4 space-x-2 border">
        {assistantSectionCheckboxFields}
      </CheckboxGroup>
    </Field>
  );
}
